module.exports = __webpack_public_path__ + "static/icon-about-320px-0b375fbd8cacf22a554293257a2434b6.png";